/**
 * @generated SignedSource<<467f1b66d542222079b1b97561ddf428>>
 * @relayHash 2e4efda0c38a168f007089d3584599c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0484bbb70ed2c638b0ab0e59b5702576207de040cf8d1aae1e3ef02dbeafad31

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyBlogUpdateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyBlogUpdateMutation$data = {
  readonly confluence: {
    readonly updateValueBlogPostProperty: {
      readonly blogPostProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyBlogUpdateMutation = {
  response: useUpdateContentPropertyBlogUpdateMutation$data;
  variables: useUpdateContentPropertyBlogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blogPostId",
        "variableName": "blogPostId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "propertyKey"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "propertyValue"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "value"
},
v7 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "updateValueBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "ConfluenceBlogPostProperty",
                "kind": "LinkedField",
                "name": "blogPostProperty",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
            "kind": "LinkedField",
            "name": "updateValueBlogPostProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "ConfluenceBlogPostProperty",
                "kind": "LinkedField",
                "name": "blogPostProperty",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2e4efda0c38a168f007089d3584599c1",
    "id": "0484bbb70ed2c638b0ab0e59b5702576207de040cf8d1aae1e3ef02dbeafad31",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{key,value,id},errors{message}}}}"
  }
};
})();

(node as any).hash = "b6f25f2e222272f4d943290de771b18f";

export default node;
